export const SET_EXCEPTION_FILTERS = 'SET_EXCEPTION_FILTERS';

export const RESET_EXCEPTION_FILTERS = 'RESET_EXCEPTION_FILTERS';

export const SET_EXCEPTION_GRID_SORT_CRITERIA = 'SET_EXCEPTION_GRID_SORT_CRITERIA';
